export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a'); anchor.href = url; anchor.download = filename;
  document.body.append(anchor); anchor.click(); anchor.remove();
  // Keep the blob alive long enough for the browser's file UI to consume it.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
export function exportText(body: string, filename = 'Nook-未完成记录.txt') {
  downloadBlob(new Blob([body], { type: 'text/plain;charset=utf-8' }), filename);
}
